import { render, staticRenderFns } from "./LectureOwn.vue?vue&type=template&id=52a3e584&"
import script from "./LectureOwn.vue?vue&type=script&lang=js&"
export * from "./LectureOwn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports